export default __webpack_public_path__ + "static/media/ios-download.ee4d86dc.PNG";